import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { Subject } from 'rxjs';

import { ImmediateStateMatcher } from '@common';
import { DevicesStore, InstallationDetailsStore } from '@store';
import { takeUntil } from 'rxjs/operators';
import { CodeScannerService } from '../../services/code-scanner.service';
import { CodeScannerResponseType } from '../../services/code-scanner.model';

@Component({
  selector: 'app-edit-serial-number-modal',
  templateUrl: './edit-serial-number-modal.component.html',
  styleUrls: ['./edit-serial-number-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditSerialNumberModalComponent implements OnInit, OnDestroy {
  serialNumberControl: FormControl<string>;
  matcher = new ImmediateStateMatcher();

  @ViewChild(MatInput, { static: false }) matInput: MatInput;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    public devicesStore: DevicesStore,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      serialNumber: string;
      editBoilerSerial?: boolean;
    },
    public codeScannerService: CodeScannerService,
    private dialogRef: MatDialogRef<EditSerialNumberModalComponent>
  ) {}

  ngOnInit(): void {
    this.serialNumberControl = new FormControl<string>(this.data.serialNumber, [
      Validators.required,
      Validators.pattern('^[0-9]{12,20}$'),
    ]);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onClear(): void {
    this.serialNumberControl.setValue('');
  }

  isSerialNumberChanged(): boolean {
    return this.serialNumberControl.value !== this.data.serialNumber;
  }

  onSaveSerialNumber(): void {
    if (this.data.editBoilerSerial) {
      this.devicesStore.updateBoilerSerial(this.serialNumberControl.value);
    } else {
      this.devicesStore.updateBmuSerial(this.serialNumberControl.value);
    }
    this.onClose();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openScanner(): void {
    this.codeScannerService
      .openCodeDialog()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response) => {
        if (response.type === CodeScannerResponseType.CODE_SCANNER_RESULT && this.matInput) {
          this.matInput.value = response.value;
          this.serialNumberControl.setValue(response.value);
        }
      });
  }
}
